module.exports = __webpack_public_path__ + "static/media/aw.6f9e741a.webp";